import { Helpers } from '../../helpers';
import { ICostCenter } from '../../interfaces/icost-center';
import { Asset } from '../asset';
import { CostCenterType } from '../cost-center-type';
import { ProjectAssetMapping } from '../project-asset-mapping';
import { ProjectCostCenter } from '../project-cost-center';

export class CostCenterBase {
  CostCenterId: number;
  CostCenterNumber: number | null;
  Description: string | null;
  CostCenterTypeId: number | null;
  IsActive: boolean;
  OperatingBusinessSegment: string | null;
  ActualNetRevenueInterest: number | null;
  ActualNetWorkingInterest: number | null;
  ActualGrossWorkingInterest: number | null;
  DivisionOrdersPayoutStatusCode: string | null;
  DivisionOrdersMajorProductCode: string | null;
  EffectiveDateTo: Date | null;
  EffectiveDateFrom: Date | null;
  OWID: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Assets_CostCenter?: Array<Asset> | null;
  ProjectAssetMappings_CostCenter?: Array<ProjectAssetMapping> | null;
  ProjectCostCenters_CostCenter?: Array<ProjectCostCenter> | null;
  CostCenterType?: CostCenterType;

  constructor(item?: ICostCenter) {
    if (item) {

      this.CostCenterId = item.CostCenterId;
      this.CostCenterNumber = item.CostCenterNumber;
      this.Description = item.Description;
      this.CostCenterTypeId = item.CostCenterTypeId;
      this.IsActive = item.IsActive;
      this.OperatingBusinessSegment = item.OperatingBusinessSegment;
      this.ActualNetRevenueInterest = item.ActualNetRevenueInterest;
      this.ActualNetWorkingInterest = item.ActualNetWorkingInterest;
      this.ActualGrossWorkingInterest = item.ActualGrossWorkingInterest;
      this.DivisionOrdersPayoutStatusCode = item.DivisionOrdersPayoutStatusCode;
      this.DivisionOrdersMajorProductCode = item.DivisionOrdersMajorProductCode;
      this.EffectiveDateTo = item.EffectiveDateTo ? new Date(item.EffectiveDateTo) : null;
      this.EffectiveDateFrom = item.EffectiveDateFrom ? new Date(item.EffectiveDateFrom) : null;
      this.OWID = item.OWID;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Assets_CostCenter = Helpers.createClassArray(Asset, item.Assets_CostCenter);
      this.ProjectAssetMappings_CostCenter = Helpers.createClassArray(ProjectAssetMapping, item.ProjectAssetMappings_CostCenter);
      this.ProjectCostCenters_CostCenter = Helpers.createClassArray(ProjectCostCenter, item.ProjectCostCenters_CostCenter);
      this.CostCenterType = new CostCenterType(item.CostCenterType);
    }
  }
}